import { observer } from "mobx-react-lite"

import type { AnalyticsCard } from "@/domains/analytics/types"

import { AnalyticsIndexView } from "../views/analytics-index-view"

export const AnalyticsIndexComposite = observer(() => {
  const cards: AnalyticsCard[] = [
    {
      title: "Epochs",
      description: "Protocol epoch analytics and emissions data",
      href: "/analytics/epochs",
    },
    {
      title: "Volume",
      description: "Platform volume analytics and insights",
      href: "/analytics/volume",
    },
  ]

  return <AnalyticsIndexView cards={cards} />
})
